import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { OfflineDriveCandidateStatus } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const driveUserStatusOptions = [
	{ value: OfflineDriveCandidateStatus.ATTENDANCE_NOT_MARKED, label: 'Attendance Not Marked' },
	{ value: OfflineDriveCandidateStatus.PRESENT, label: 'Present' },
	{ value: OfflineDriveCandidateStatus.BUSY, label: 'Busy' },
	{ value: OfflineDriveCandidateStatus.HIRED, label: 'Hired' },
	{ value: OfflineDriveCandidateStatus.IDLE, label: 'Idle' },
	{ value: OfflineDriveCandidateStatus.ASSIGN, label: 'Assign' },
];

const DriveUserStatusFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const userStatus = JSON.parse(searchParams.get('userStatus') || '[]');

	const options = driveUserStatusOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!userStatus?.length}
					placeholder={'Status'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: userStatus?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (userStatus?.includes(option?.value?.toString())) {
											searchParams.set(
												'userStatus',
												JSON.stringify(userStatus?.filter((status: string) => status !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('userStatus', JSON.stringify([...userStatus, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{userStatus?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Status</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Idle"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => userStatus?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('userStatus', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default DriveUserStatusFilterInput;
